<template>
  <div class="doencas-details">
    <page-header :title="title" />
    <page-section :group-label="$t('Cronicas')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Doencas')"
            :value="pessoa.doencas | toPT_BRCapitalize"
            :is-restrict="$store.getters['pessoa/isRestrict']('doencas')"
          />
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Alergias')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Alergias')"
            :value="pessoa.alergias | toPT_BRCapitalize"
            :is-restrict="$store.getters['pessoa/isRestrict']('alergias')"
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="pessoa" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Doencas") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Doencas"),
  }),
  computed: {
    pessoa() {
      return this.$store.state.pessoa.data || {};
    },
  },
};
</script>

<style scoped></style>
